import { RadPdfFormResponse } from "@/Common/Api/RadPdf/RadPdfFormResponse";

export class RadPdfFormData {
    public formId: string;
    public formName: string;

    public static fromResponseModel(formResponse: RadPdfFormResponse): RadPdfFormData {
        if (!formResponse)
            return null;

        return {
            formId: formResponse.FormId,
            formName: formResponse.FormName
        };
    }

    public static fromResponseModelArray(formResponse: RadPdfFormResponse[]): RadPdfFormData[] {
        return formResponse?.map(form => this.fromResponseModel(form));
    }
}
